export default __webpack_public_path__ + "static/encia-946ddd2e91a373c552e3c6764fd85b66.png";